<template>
   
    <div> 
        <div class="crumbs" hidden="true"  style="margin-left:10px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 产品管理
                </el-breadcrumb-item>
                <el-breadcrumb-item>我的订单</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
          <el-card shadow="hover"  class="searchCard" > 
                <span class="label-span">
                    <label class="label">订单时间段</label> 
                    <el-date-picker v-model="query.startTime" :picker-options="pickerOptions1" value-format="yyyy-MM-dd HH:mm:ss" style="width:200px;" type="datetime"  placeholder="开始时间"></el-date-picker>
                    <el-date-picker v-model="query.endTime" :picker-options="pickerOptions2" value-format="yyyy-MM-dd HH:mm:ss" style="width:200px;margin-right:10px;" type="datetime"   placeholder="结束时间"></el-date-picker>
                </span>   
                 <span class="label-span">
                        <label class="label">系统单号</label> 
                        <el-input v-model.trim="query.orderNo" placeholder="系统单号"  class="handle-input mr10"></el-input> 
                    </span>  
                <span class="label-span">
                    <label class="label">下游单号</label> 
                    <el-input v-model.trim="query.orderOno" placeholder="请输入下游单号"  class="handle-input mr10"></el-input> 
                </span>  
                <span class="label-span">
                    <label class="label">用户号码</label> 
                    <el-input v-model.trim="query.phone" placeholder="请输入用户号码" class="handle-input mr10"></el-input> 
                </span>    
                <span class="label-span">
                    <label class="label">订单状态</label> 
                    <el-select v-model="query.status"  placeholder="订单状态" filterable  clearable class="handle-select mr10">
                        <el-option value="" label="全部"  /> 
                        <el-option value="0" label="校验失败"  /> 
                        <el-option value="1" label="校验成功"  /> 
                        <el-option value="2" label="短信失败"  />  
                        <el-option value="3" label="短信成功"  />  
                        <el-option value="4" label="回填失败"  />  
                        <el-option value="5" label="回填成功"  />    
                        <el-option value="-1" label="订购失败"  />  
                        <el-option value="9" label="订购成功"  />  
                    </el-select>  
                </span>   
                <span class="label-span">
                    <label class="label">产品名称</label> 
                    <el-input v-model.trim="query.goodsName" placeholder="系统产品名称"  class="handle-input mr10"></el-input> 
                </span>  
                <span class="label-span">
                        <label class="label">产品编码</label> 
                        <el-input v-model.trim="query.goodsCode" placeholder="系统产品编码" class="handle-input mr10"></el-input> 
                    </span>   
                     <label class="label">计费通道</label> 
                    <el-select v-model="query.isp"  placeholder="计费通道" filterable  clearable class="handle-select mr10">
                        <el-option value="" label="全部"  />
                        <el-option value="1" label="移动"  /> 
                        <el-option value="2" label="联通"  /> 
                        <el-option value="3" label="电信"  />  
                        <el-option value="0" label="自收款" /> 
                        <el-option value="9" label="代收款" />    
                    </el-select>     
                    <span class="label-span">
                        <label class="label">推送状态</label> 
                        <el-select v-model="query.isPush"  placeholder="推送状态" filterable  clearable class="handle-select mr10">
                            <el-option value="" label="全部"  /> 
                            <el-option value="0" label="待推送"  /> 
                            <el-option value="1" label="已推送"  />  
                            <el-option value="2" label="推送确认"  />  
                            <el-option value="-1" label="推送异常"  />  
                        </el-select> 
                    </span>  

                <el-button type="success" icon="el-icon-search"  class="mr10"  @click="handleSearch">搜索</el-button>
                <el-button type="error" icon="el-icon-refresh" class="mr10"  @click="refreshSearch">重置</el-button>  
                <el-button type="error" icon="el-icon-download" class="mr10" @click="downExcel">导出</el-button>  
            </el-card>
            <el-card shadow="hover"  class="containCard" >
            <el-table :data="tableData" height="600px" style="margin-top:-10px" border class="table"  ref="multipleTable" header-cell-class-name="table-header" v-loading="loading"  element-loading-text="" element-loading-spinner="el-icon-loading"  @selection-change="handleSelectionChange"  >
          
                <el-table-column type="selection" width="45" align="center"></el-table-column>    
                <el-table-column prop="orderNo" width="245" align="left" label="订单号">
                    <template slot-scope="scope">
                        <p style="font-size:12px;line-height:18px;"> 
                        系统单号:<el-tooltip :content="scope.row.orderNo" placement="top">
                            <el-link v-if="scope.row.orderNo" type="primary" style="font-size:10px;" @click="copyLink(scope.row.orderNo,'系统单号')">{{scope.row.orderNo}}</el-link> <br>
                        </el-tooltip><br>
                        下游单号:<el-tooltip :content="scope.row.orderOno" placement="top"> 
                            <el-link v-if="scope.row.orderOno" type="primary" style="font-size:10px;" @click="copyLink(scope.row.orderOno,'下游单号')">{{scope.row.orderOno}}</el-link> <br>
                        </el-tooltip>
                        </p>
                    </template>
                </el-table-column>    
                <el-table-column prop="goodsName" width="170" align="left" label="渠道信息">
                    <template slot-scope="scope" >
                        <p style="font-size:12px;line-height:18px;"> 
                        下游渠道：<span @click="copyLink(scope.row.loginName,'下游渠道')">{{scope.row.loginName}}</span> <br>
                        用户号码：<span @click="copyLink(scope.row.phone,'用户号码')">{{scope.row.phone}}</span>
                       </p>
                    </template>
                </el-table-column>    
                <el-table-column prop="goodsName" min-width="200" align="left" label="产品信息">
                    <template slot-scope="scope" >
                        <p style="font-size:12px;line-height:18px;">
                        产品编码：<el-link type="primary" style="font-size:12px;" @click="copyLink(scope.row.goodsCode,'产品编码')">{{scope.row.goodsCode}}</el-link> <br>
                        产品名称：<el-link type="primary" style="font-size:12px;display:inline;line-height:18px;"  @click="copyLink(scope.row.goodsName,'产品名称')">{{scope.row.goodsName}}</el-link> 
                         
                        </p>
                    </template>
                </el-table-column>     
                <el-table-column prop="goodsName" min-width="220" align="left" label="订单状态">
                    <template slot-scope="scope" >
                        <p style="font-size:12px;line-height:20px;"> 
                        状态：<el-tag :type="scope.row.status==9?'success':scope.row.isDeduction==1?'danger':scope.row.status==-1?'danger':scope.row.status==5?'primary':'info'">{{scope.row.status==0?"校验失败":scope.row.status==1?"校验成功":scope.row.status==2?"短信失败":scope.row.status==3?"短信成功":
                            scope.row.status==4?"回填失败":scope.row.status==5?"回填成功":scope.row.status==-1?"订购失败":scope.row.status==9?"订购成功":scope.row.status}}</el-tag>
                        <el-tag style="margin-left:10px;" :type="scope.row.isPush==-1?'danger':scope.row.isPush==2?'success':scope.row.isPush==1?'success':'info'">{{scope.row.isPush==0?"待推送":scope.row.isPush==1?"已推送":scope.row.isPush==2?"推送确认":scope.row.isPush==-1?"推送异常":"其它"}}</el-tag>
                       <br> 
                      <span v-if="scope.row.message!=null && scope.row.parmessageam!=''">
                            <el-popover placement="bottom" title="详细信息"  width="400" trigger="hover" :content="scope.row.message">
                                <span style="background:none;color:#666;border:none;" slot="reference" >{{scope.row.message.length>40?scope.row.message.substr(0,37)+'...':scope.row.message}}</span>
                            </el-popover> 
                        </span>
 
                        
                        </p>
                   </template>
                </el-table-column>             
                <el-table-column prop="createTime" width="210" align="left"  label="订单时间">
                    <template slot-scope="scope" >
                        <p style="font-size:12px;line-height:16px;">
                        订单创建：{{scope.row.createTime}}<br> 
                        推送时间：{{scope.row.pushTime}}
                        </p>
                   </template>   
                </el-table-column>   
                <el-table-column label="操作" width="101" align="center"  fixed="right">
                    <template slot-scope="scope">     
                        <span class='tableOperBtn'  @click="handleDetail(scope.row)"><i class='el-icon-lx-attention'></i> 用户信息</span>
                        <span class='tableOperBtn' @click="handleStep(scope.row)"><i class='el-icon-lx-attention'></i> 订单轨迹</span>
                        <!-- <br> <el-button @click="handlePush(scope.row)">订单推送</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination 
                   background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange" 
                ></el-pagination>
            </div>
            </el-card> 
        <!-- 新建自主资源弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="变更状态" :visible.sync="addVisible" :modal-append-to-body='false' top="80px" width="420px">
            <el-form ref="form1" :model="form1" label-width="90px">
                <el-form-item label="订单状态">
                    <el-radio-group  v-model.trim="form1.status" >
                        <el-radio-button label="0">校验失败</el-radio-button> 
                        <el-radio-button label="1">校验成功</el-radio-button> 
                        <el-radio-button label="2">短信失败</el-radio-button> 
                        <el-radio-button label="3">短信成功</el-radio-button> 
                        <el-radio-button label="4">回填失败</el-radio-button> 
                        <el-radio-button label="5">回填成功</el-radio-button> 
                        <el-radio-button label="8">回调超时</el-radio-button> 
                        <el-radio-button label="-1">订购失败</el-radio-button> 
                        <el-radio-button label="9">订购成功</el-radio-button>   
                    </el-radio-group>   
                </el-form-item>  
                <el-form-item label="状态描述">
                    <el-input v-model.trim="form1.message"  placeholder="状态描述" ></el-input>
                </el-form-item>  
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">确 定</el-button>
            </span>
        </el-dialog> 

        <el-dialog :close-on-click-modal="false" title="用户信息" :visible.sync="detailVisible" :modal-append-to-body='false' top="50px" width="480px">
            <p class="label-span">
                <label class="label">手机号码</label> 
                <span style="margin-left:15px">{{form2.phone}}</span>
            </p> <br>
            <p class="label-span"> 
                <label class="label">验证码</label> 
                <span style="margin-left:15px">{{form2.sms}}</span>
            </p> <br>
            <p class="label-span">
                <label class="label">号码归属地</label> 
                <span style="margin-left:15px">{{form2.area}}</span>
            </p> <br>
            <p class="label-span">
                <label class="label">号码运营商</label> 
                <span style="margin-left:15px">{{form2.isp==1?"移动":form2.isp==2?"联通":form2.isp==3?"电信":form2.isp==4?"广电":""}}</span>
            </p> <br> 
            <p class="label-span">
                <label class="label">落地页链接</label> 
                <el-link @click="copyLink(form2.link,'落地页链接')" type="success" style="margin-left:15px">{{form2.link}}</el-link>
            </p> <br>
            <p class="label-span">
                <label class="label">投放平台</label> 
                <span style="margin-left:15px">{{form2.platform}}</span>
            </p> <br> 
            <p class="label-span">
                <label class="label">用户触点</label> 
                <span style="margin-left:15px">{{form2.contact}}</span>
            </p> <br>
            <p class="label-span">
                <label class="label">用户IP</label> 
                <span style="margin-left:15px">{{form2.userIp}}</span>
            </p> <br>
            <p class="label-span">
                <label class="label">APP包名</label> 
                <span style="margin-left:15px">{{form2.appPackage}}</span>
            </p> <br>
            <p class="label-span">
                <label class="label">浏览器标识</label> 
                <span style="margin-left:15px;color:#999;font-size:12px">{{form2.ua}}</span>
            </p> <br>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="订单轨迹" :visible.sync="stepVisible" :modal-append-to-body='false' top="50px" width="1250px">
            <div style="margin-top:-10px;height:35px;color:#666;font-size:16px;margin-left:15px;height:500px;overflow-y:scroll">
                当前订单号: <span style="color:#333;font-weight:700;margin-right:30px">{{form5.orderNo}}
                    </span>
                当前订单状态:
                <el-tag style="font-size:16px;" :type="form.status==9?'success':form5.status==-1?'danger':form5.status==8?'warning':'info'">{{form5.status==0?"校验失败":form5.status==1?"校验成功":form5.status==2?"短信失败":form5.status==3?"短信成功":
                    form5.status==4?"回填失败":form5.status==5?"回填成功":form5.status==-1?"订购失败":form5.status==9?"订购成功":form5.status==8?"回调超时":"其它"}}</el-tag>
                <el-table :data="form4" border class="table"  ref="multipleTable" header-cell-class-name="table-header"   >
                    <el-table-column prop="step" width="70" align="left" label="序号">
                        <template slot-scope="scope">
                            {{scope.$index+1}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="step" width="160" align="left" label="执行步骤">
                        <template slot-scope="scope">
                            {{scope.row.step==1?"用户校验-订单创建":scope.row.step==2?"用户校验-系统校验":scope.row.step==3?"用户校验-接口调用":scope.row.step==4?"短信发送-接口调用":
                            scope.row.step==5?"短信回填-系统校验":scope.row.step==6?"短信回填-接口调用":scope.row.step==7?"订购结果-上游回调":
                                scope.row.step==0?"系统订单-订单破解":scope.row.step==8?"订购结果-主动查询":scope.row.step==9?"订购结果-回调超时":scope.row.step==10?"订购结果-回调确认":
                                    scope.row.step==11?"订购结果-查询确认":scope.row.step==12?"订购结果-查询确认":scope.row.step==13?"订购结果-下游推送":scope.row.step==14?"订单限量-到量计算":scope.row.step==15?"退订导入-变更状态":""}}</template>
                    </el-table-column>
                    <el-table-column prop="stepStatus" width="85" align="center" label="执行结果">
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.stepStatus==1?'success':scope.row.stepStatus==0?'warning':scope.row.stepStatus==-1?'danger':''">
                                {{scope.row.stepStatus==1?"执行成功":scope.row.stepStatus==0?"执行失败":scope.row.stepStatus==-1?"执行异常":""}}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="stepStatus" width="85" align="center" label="执行方式">
                        <template slot-scope="scope">
                            <span>{{scope.row.operType==1?'系统执行':scope.row.operType==2?'系统轮询':scope.row.operType==3?'人工操作':"-"}}
                            </span>
                        </template>
                    </el-table-column>
<!--                    <el-table-column prop="stepStatus" min-width="120" align="left" label="下游请求信息">-->
<!--                        <template slot-scope="scope">-->
<!--                            <p v-if="scope.row.param!=null && scope.row.param!=''">-->
<!--                                <el-popover placement="bottom" title="详细信息"  width="600" trigger="hover" :content="scope.row.param">-->
<!--                                    <span style="background:none;color:blue;border:none;font-size:12px;" slot="reference" >{{scope.row.param.length>23?scope.row.param.substr(0,20)+'...':scope.row.param}}</span>-->
<!--                                </el-popover>-->
<!--                            </p>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
                    <el-table-column prop="stepStatus" min-width="120" align="left" label="系统返回信息">
                        <template slot-scope="scope">
                            <p v-if="scope.row.info!=null && scope.row.info!=''">
                                <el-popover placement="bottom" title="详细信息"  width="600" trigger="click" :content="scope.row.info">
                                    <span style="background:none;color:blue;border:none;font-size:12px;" slot="reference" >{{scope.row.info.length>23?scope.row.info.substr(0,19)+'...':scope.row.info}}</span>
                                </el-popover>
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createTime" fixed="right" width="160" align="center"  label="执行时间"></el-table-column>
                </el-table>

                <el-tooltip  :content="showDiv2?'展开查看接口请求':'收起接口请求数据'" placement="top">
                    <el-link type="error" style="margin-top:10px;color:blue"  @click="showMore2"> {{show2}} </el-link>
                </el-tooltip>
                <span :hidden="showDiv2">
                    <!-- 表格主体 -->
                    <el-table
                        :data="form7"
                        border class="table"
                        style="width: 100%;margin-top:5px !important"
                        empty-text="暂无数据" >
                        <el-table-column prop="step" width="70" align="left" label="序号">
                                <template slot-scope="scope">
                                    {{scope.$index+1}}
                                </template>
                            </el-table-column>
                        <el-table-column   label="执行步骤"  width="160" align="center" >
                            <template slot-scope="scope">
                                {{
                                    scope.row.downstreamRequestUrl.includes('/sendSms')||  scope.row.downstreamRequestUrl.includes('/sendTemplate') ? '发送验证码' :
                                        scope.row.downstreamRequestUrl.includes('checkUserInfo') ? '用户校验' :
                                            scope.row.downstreamRequestUrl.includes('/callback/')||scope.row.downstreamRequestUrl.includes('/callbackPJ/') ? '上游回调' :
                                                scope.row.downstreamRequestUrl.includes('submitSms')|| scope.row.downstreamRequestUrl.includes('submitTemplate') ? '提交验证码' :
                                                    scope.row.downstreamRequestUrl.includes('getResult')  ? '主动查询' :
                                                        '未知操作'
                                }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="downstreamRequestParams" label="下游请求参数"  align="left" >
                            <template slot-scope="scope">
                                <p v-if="scope.row.downstreamRequestParams!=null && scope.row.downstreamRequestParams!=''">
                                    <el-popover placement="bottom" title="下游请求参数"  width="600" trigger="hover"  >
                                        <div style="max-height: 300px; overflow-y: auto;">
                                            <json-viewer :value="parseJson(scope.row.downstreamRequestParams)" :expand-all="true" />
                                        </div>
                                        <span style="background:none;color:blue;border:none;font-size:12px;" slot="reference" >{{scope.row.downstreamRequestParams.length>18?scope.row.downstreamRequestParams.substr(0,15)+'...':scope.row.downstreamRequestParams}}</span>
                                    </el-popover>
                                </p>
                            </template>
                        </el-table-column>
                        <el-table-column prop="downstreamResponseParams" label="响应下游参数"  align="left" >
                            <template slot-scope="scope">
                                <p v-if="scope.row.downstreamResponseParams!=null && scope.row.downstreamResponseParams!=''">
                                    <el-popover placement="bottom" title="下游请求参数"  width="600" trigger="hover"  >
                                        <div style="max-height: 300px; overflow-y: auto;">
                                            <json-viewer :value="parseJson(scope.row.downstreamResponseParams)" :expand-all="true" />
                                        </div>
                                        <span style="background:none;color:blue;border:none;font-size:12px;" slot="reference" >{{scope.row.downstreamResponseParams.length>18?scope.row.downstreamResponseParams.substr(0,15)+'...':scope.row.downstreamResponseParams}}</span>
                                    </el-popover>
                                </p>
                            </template>
                        </el-table-column>

                        <el-table-column prop="upstreamElapsedTime" label="上游接口耗时" width="115" align="center">
                            <template slot-scope="scope">
                                {{ scope.row.upstreamElapsedTime ? scope.row.upstreamElapsedTime : '0' }} ms
                            </template>
                        </el-table-column>
                        <el-table-column prop="totalElapsedTime" label="下游接口耗时" width="115" align="center" >
                        <template slot-scope="scope">
                            {{scope.row.totalElapsedTime}} ms
                            </template>

                        </el-table-column>
                        <el-table-column prop="totalElapsedTime" label="系统运行耗时" width="115" align="center" >
                            <template slot-scope="scope">
                                {{ scope.row.totalElapsedTime - scope.row.upstreamElapsedTime  }} ms
                            </template>
                        </el-table-column>
                    </el-table>
                </span>
            </div>
            <div style="clear:both"></div>
        </el-dialog>


         
        
          
    </div>
</template>

<script>
import {fetchData, getOrderDetail,downMyOrderExcel } from '../../api/comMyOrder';  
import { changePush} from '../../api/comOrderPush';
import { getOrderStep } from '@/api/comOrder';
import JsonViewer from 'vue-json-viewer';
 
export default {

    data() {
        return {
            dialogFormVisible: false,
            formLabelWidth: '120px',
            jsonData: {
                key1: "value1",
                key2: 2,
                key3: true
            },
            formattedJson: "",
            Timeout:'',
            activeNames:1,
            select1:{ option:'',  },
            select2:{ option:'',  },
            select3:{ option:'',  },
            select6:{ option:'',  },
            sendSms:{
                code:'',
                content:'发送验证码',
                type:'danger',
                disabled:false,
                color:'color:#fff',
            },
            formImg:{
                img2:'',
                img3:'',
            },
            query: {
                isPj: "0",
                pageIndex: 1,
                pageSize: 10,
                phoneList: '',
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            showDiv:true,
            showDiv2:true,
            show:'v',
            show2:'● 查看接口请求数据 >',
            editVisible: false,
            dataVisible:false,
            editPlusVisible: false,
            addVisible: false,
            addPlusVisible:false,
            detailVisible:false,
            backVisible:false,
            stepVisible:false,
            drawVisible:false,
            loading:false,
            row:{},
            pageTotal: 0,
            formtd: {
                cid:'',
                startTime:'',
                endTime:'',
                file: ''
            },
            formtdRules: {
                cid: [
                    { required: true, message: '请选择上游资源', trigger: 'blur' }
                ],
                startTime: [
                    { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
                ],
                endTime: [
                    { type: 'date', required: true, message: '请选择时间', trigger: 'change' }
                ]

            },
            form: {
                ids:'',
                names:'',
            },
            form1: {
                smsFrom:'1',
                smsType:'1',
            },
            form2: {  },
            form3: {  phone:'',sms:''  },
            form4: {   },
            form5: {   },
            form6: {   },
            form7: {   },
            idx: -1,
            id: -1,
            ids:'',
            pickerOptions1: {
                shortcuts: [{
                    text: '今天',
                    onClick(picker) {
                        var nowDate = new Date();
                        var date = {
                            year: nowDate.getFullYear(),
                            month: nowDate.getMonth(),
                            day: nowDate.getDate()
                        };
                        if(date.month==0){
                            date.month = 12;
                            date.year =  date.year - 1;
                        }else{
                            date.month = date.month +1;
                        }
                        const dayDate1 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day)+" 00:00:00";
                        picker.$emit('pick', dayDate1);
                    }
                }, {
                    text: '昨天',
                    onClick(picker) {
                        const nowDate = new Date();
                        nowDate.setTime(nowDate.getTime() - 3600 * 1000 * 24);
                        var date = {
                            year: nowDate.getFullYear(),
                            month: nowDate.getMonth(),
                            day: nowDate.getDate()
                        };
                        if(date.month==0){
                            date.month = 12;
                            date.year =  date.year - 1;
                        }else{
                            date.month = date.month +1;
                        }
                        const dayDate1 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day)+" 00:00:00";
                        picker.$emit('pick', dayDate1);

                    }
                },{
                    text: '2天前',
                    onClick(picker) {
                        const nowDate = new Date();
                        nowDate.setTime(nowDate.getTime() - 3600 * 1000 * 48);
                        var date = {
                            year: nowDate.getFullYear(),
                            month: nowDate.getMonth(),
                            day: nowDate.getDate()
                        };
                        if(date.month==0){
                            date.month = 12;
                            date.year =  date.year - 1;
                        }else{
                            date.month = date.month +1;
                        }
                        const dayDate1 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day)+" 00:00:00";
                        picker.$emit('pick', dayDate1);
                    }
                }]
            },
            pickerOptions2: {
                shortcuts: [{
                    text: '今天',
                    onClick(picker) {
                        var nowDate = new Date();
                        var date = {
                            year: nowDate.getFullYear(),
                            month: nowDate.getMonth(),
                            day: nowDate.getDate()
                        };
                        if(date.month==0){
                            date.month = 12;
                            date.year =  date.year - 1;
                        }else{
                            date.month = date.month +1;
                        }
                        const dayDate1 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day)+" 23:59:59";
                        picker.$emit('pick', dayDate1);
                    }
                }, {
                    text: '昨天',
                    onClick(picker) {
                        const nowDate = new Date();
                        nowDate.setTime(nowDate.getTime() - 3600 * 1000 * 24);
                        var date = {
                            year: nowDate.getFullYear(),
                            month: nowDate.getMonth(),
                            day: nowDate.getDate()
                        };
                        if(date.month==0){
                            date.month = 12;
                            date.year =  date.year - 1;
                        }else{
                            date.month = date.month +1;
                        }
                        const dayDate1 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day)+" 23:59:59";
                        picker.$emit('pick', dayDate1);

                    }
                },{
                    text: '2天前',
                    onClick(picker) {
                        const nowDate = new Date();
                        nowDate.setTime(nowDate.getTime() - 3600 * 1000 * 48);
                        var date = {
                            year: nowDate.getFullYear(),
                            month: nowDate.getMonth(),
                            day: nowDate.getDate()
                        };
                        if(date.month==0){
                            date.month = 12;
                            date.year =  date.year - 1;
                        }else{
                            date.month = date.month +1;
                        }
                        const dayDate1 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day)+" 23:59:59";
                        picker.$emit('pick', dayDate1);
                    }
                }]
            },
        };
    },
    components: {
        JsonViewer
    },
    created() {
        // 默认当天0点
        /*var nowDate = new Date();
        var date = {
            year: nowDate.getFullYear(),
            month: nowDate.getMonth(),
            day: nowDate.getDate()
        };
        if(date.month==0){
            date.month = 12;
            date.year =  date.year - 1;
        }else{
            date.month = date.month +1;
        }
        const dayDate1 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day)+" 00:00:00";
        const dayDate2 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day)+" 23:59:59";
    
        this.$set(this.query, "startTime", dayDate1.toString());  
        this.$set(this.query, "endTime", dayDate2.toString());   */
    },
    //页面加载方法
    mounted: function () { 
        //查询列表
        // this.getSelect1();
        // this.getSelect2();
        // this.getSelect6();
        this.getData();

    },

    methods: {  
        // 触发搜索按钮 
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },

        //重置按钮
        refreshSearch(){ 
            this.$set(this.query, 'startTime');  
            this.$set(this.query, 'endTime');  
            this.$set(this.query, 'startTime2');  
            this.$set(this.query, 'endTime2');  
            this.$set(this.query, 'cid');  
            this.$set(this.query, 'loginName');  
            this.$set(this.query, 'phone');  
            this.$set(this.query, 'orderTno');  
            this.$set(this.query, 'orderOno');  
            this.$set(this.query, 'status');    
            this.$set(this.query, 'goodsName');    
            this.$set(this.query, 'ctype');    
            this.$set(this.query, 'orderNo');    
            this.$set(this.query, 'goodsCode');    
            this.$set(this.query, 'channelGoodsCode');    
            this.$set(this.query, 'goodsRate');    
            this.$set(this.query, 'goodsIsp');    
            this.$set(this.query, 'goodsComType');    
            this.$set(this.query, 'memPhone');    
            this.$set(this.query, 'message');    
            this.$set(this.query, 'isDeduction');    
            this.$set(this.query, 'isPush');    
            this.$set(this.query, 'isBack');    
            this.handleSearch();
        }, 
        
        getMore(data){
             this.$notify({  message: data,duration: 3000 });
        },
        handleSelectionChange(val) {
            this.multipleSelection = val; 
        },
        parseJson(jsonStr) {
            try {
                return JSON.parse(jsonStr);
            } catch (e) {
                return { error: '无效的 JSON 格式', raw: jsonStr };
            }
        },
        showMore2(){
            if(this.showDiv2){
                this.show2 = '● 收起接口请求数据 V';
                this.showDiv2 = false;
            }else{
                this.show2 = '● 查看接口请求数据 >';
                this.showDiv2 = true;
            }
        },
        showMore(){
            if(this.showDiv){
                this.show = '>';
                this.showDiv = false;
            }else{
                this.show = 'v';
                this.showDiv = true;
            } 
        },
        handleBackSys(orderNo){
            let data = {};
            data.orderNo = orderNo; 
            backSys(data).then(res => {   
                if(res.code=='200'){ 
                    this.handleBack(this.form5); 
                    this.$notify({ title: '成功', message: '回调成功',duration: 1000, type: 'success' });
                }else{
                    this.$notify({ title: '失败', message: '回调失败'+res.message,duration: 1000, type: 'danger' });
                }
            });
        },
        handlePushMem(orderNo){
            let data = {};
            data.orderNo = orderNo;
            pushMem(data).then(res => {   
                if(res.code=='200'){ 
                    this.$notify({ title: '成功', message: '推送成功',duration: 1000, type: 'success' });
                }else{
                    this.$notify({ title: '失败', message: '推送失败'+res.message,duration: 1000, type: 'danger' });
                }
            });
        },

        batchPush(){
             const length = this.multipleSelection.length; 
            if(length===0){
                this.$message.error("请勾选要执行推送的订单");
                return;
            }
            var that = this;
            that.$confirm('确认执行批量推送吗？', '提示', {
                type: 'warning'
            }).then(() => { 
                this.loading = true;  
                setTimeout(() => {
                    if(this.loading){
                        this.loading = false;  
                        this.getData();
                        this.$message("等待后台执行..."); 
                    } 
                }, 5000);   
                for (let i = 0; i < length; i++) { 
                    setTimeout(() => {
                        that.handlePush2(that.multipleSelection[i]);
                    }, 350*i);  
                    if(i==length-1){
                        setTimeout(() => {
                            this.loading = false;  
                            this.getData();
                        }, 1500); 
                    }
                }   
            });
        },
        handlePush2(row){   
            changePush(row).then(res => {
                if(res.code=='200'){ 
                    this.$notify({ title: '成功', message: row.orderNo+'推送执行成功',duration: 1000, type: 'success' });
                }else{
                    this.$notify({ title: '失败', message:  row.orderNo+'推送执行失败：'+res.message,duration: 5000, type: 'error' });
                }
            });  
        },

        handlePush(row){
            if(row.isDeduction==0){
                this.$message.error("请先进行扣量计算后再执行推送！");
                return;
            }
            var that = this;  
            that.$confirm('确认执行推送吗？', '提示', {
                type: 'warning'
            }).then(res => {  
                that.loading = true;  
                changePush(row).then(res => {
                    that.loading = false;  
                    if(res.code=='200'){ 
                        that.$notify({ title: '成功', message: row.orderNo+'推送执行成功',duration: 1000, type: 'success' });
                        setTimeout(() => {
                            that.getData();
                        }, 1000);   
                    }else{
                        that.$notify({ title: '失败', message:  row.orderNo+'推送执行失败：'+res.message,duration: 5000, type: 'error' });
                    }
                });  
            });        
        },
        handleDeduc(row){ 
            var that = this;
            that.$confirm('确认执行扣量吗？', '提示', {
                type: 'warning'
            }).then(() => { 
                that.loading = true;  
                changeDeduc(row).then(res => {
                    that.loading = false;  
                    if(res.code=='200'){ 
                        that.$notify({ title: '成功', message: row.orderNo+'推送执行成功',duration: 1000, type: 'success' });
                        setTimeout(() => {
                            that.getData();
                        }, 1000);   
                    }else{
                        that.$notify({ title: '失败', message:  row.orderNo+'推送执行失败：'+res.message,duration: 5000, type: 'error' });
                    }
                }); 
            });
        },
 

        //触发刷新按钮
        refresh(){
            history.go(0);
            
        }, 
        setReamrks(index,row){ 
            let data = {};
            data.remarks = row.remarks;
            data.id = row.id;
            update(data).then(res => {   
                if(res.code=='200'){ 
                    this.$notify({ title: '成功', message: '设置成功',duration: 1000, type: 'success' });
                }else{
                    this.$notify({ title: '失败', message: '设置失败'+res.message,duration: 1000, type: 'danger' });
                }
            });
        },
        setReamrksMore(){
            
        },
        downExcel(){
            this.loading = true
            setTimeout( () => {
                this.loading = false;  
                this.getData();
            }, 7000) 
            downMyOrderExcel(this.query).then(res => {   
                this.loading = false
                if(res.code=='200'){ 
                    this.$notify({ title: '成功', message: '后台下载成功',duration: 1000, type: 'success' });
                }else{
                    this.$notify({ title: '失败', message: '后台下载异常',duration: 5000, type: 'error' });
                }
            });
        },
        //获取下拉框数据
        getSelect1(){ 
            this.select1 = {};  
            fetchSelect1(this.select1).then(res => {   
                if(res.code=='200'){ 
                    this.$set(this.select1, 'option', res.data);  
                }
            });
        },
        getSelect2(){ 
            this.select2 = {}; 
            fetchSelect2(this.select2).then(res => {   
                if(res.code=='200'){ 
                    this.$set(this.select2, 'option', res.data);  
                }
            });
        },
        getSelect3(){ 
            this.select3 = {}; 
            fetchSelect3(this.select3).then(res => {   
                if(res.code=='200'){ 
                    this.$set(this.select3, 'option', res.data);  
                }
            });
        },
        getSelect6(){ 
            this.select6 = {};  
            fetchSelect6(this.select6).then(res => {   
                if(res.code=='200'){ 
                    this.$set(this.select6, 'option', res.data);  
                }
            });
        },
        //查询
        getData(){  
            this.loading = true;
            // 过滤掉无效字段
            const filteredQuery = Object.keys(this.query).reduce((acc, key) => {
                const value = this.query[key];
                // 过滤掉 null、undefined、空字符串、0、false 等无效值
                if (value !== null && value !== undefined && value !== '') {
                    acc[key] = value;
                }
                return acc;
            }, {});

            fetchData(filteredQuery).then(res => {
                this.loading = false;
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal ;  
                }else{
                    this.tableData = []; 
                    this.pageTotal = 0;
                } 
                
            });
        },
          
        copyLink(text,name){  
            var copy = document.createElement("input");
            copy.setAttribute("value", text);
            document.body.appendChild(copy);
            copy.select();
            document.execCommand("copy");
            document.body.removeChild(copy);  
            //提示已复制
            this.$message.success(name+"复制成功");  
        },
        

        handleRemarksMore(){
            const length = this.multipleSelection.length; 
            if(length===0){
                this.$message.error("请勾选要备注的订单");
                return;
            }
            this.ids = '';
            for (let i = 0; i < length; i++) { 
                this.ids += this.multipleSelection[i].id + ',';  
            }  
            this.ids = this.ids.substr(0,this.ids.length-1);  
            this.form3.id = this.ids;
            this.editVisible = true;
        }, 
       
        // 保存更改
        saveEdit() {    
            if( !this.form3.remarks ){
                this.$message.error("请填写订单备注");
                return;
            }    
            updateMore(this.form3).then(res => {
                if(res.code=='200'){
                    this.editVisible = false; 
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.$message.error(res.message); 
                }
            });
        },

        // 修改状态
        setStatus(row) {
            this.form1 = row;
            this.addVisible = true; 
        },
        
         handleStatusMore(){
            const length = this.multipleSelection.length; 
            if(length===0){
                this.$message.error("请勾选要变更状态的订单");
                return;
            }
            this.ids = '';
            for (let i = 0; i < length; i++) { 
                this.ids += this.multipleSelection[i].id + ',';  
            }  
            this.ids = this.ids.substr(0,this.ids.length-1);  
            this.form1.id = this.ids;
            this.addVisible = true;
        },
        getDetail(row){

        },
        //保存新增
        saveForm() {   
            if( !this.form1.status ){
                this.$message.error("请选择订单变更状态");
                return;
            }  
            if( !this.form1.message ){
                this.$message.error("请填写状态描述");
                return;
            }    
            this.addVisible = false;
            if(this.form1.status==5){
                this.form1.isBack = 0;
            }
            this.form1.param = localStorage.getItem(window.location.hostname+'_loginName')+"-"+localStorage.getItem(window.location.hostname+'_phone');  
            changeStatusMore(this.form1).then(res => {
                if(res.code=='200'){
                   
                    this.addPlusVisible = false;
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                     this.addVisible = true;
                    this.$message.error(res.message); 
                } 
            });
        }, 

        // q启用、禁用--改变状态
        handleStatus(index, row) {  
            var tips ;
            var content;
            if(row.status=='0'){ 
                tips = "禁用";
                content = "确定禁用吗？";
            }else{ 
                tips = "启用";
                content = "确定启用吗？"; 
            }
            // 二次确认删除
            this.$confirm(content, '提示', {
                type: 'warning'
            }).then(() => { 
                changeStatus(row).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success(tips+'成功'); 
                        this.getData();
                    }else{ 
                        this.$message.error(tips+'失败');
                    } 
                });
            })
            .catch(() => {}); 
           
        },
 
        
        //详情
        handleDetail( row){  
            getOrderDetail(row).then(res => {
                if(res.code=='200'){
                    this.detailVisible = true;  
                    this.form2 = res.data;
                    this.form2.phone = row.phone; 
                    this.form2.sms = row.sms;
                }else{
                    this.$message.error(res.message); 
                } 
            }); 
        },
        handleStep( row){
            getOrderStep(row).then(res => {
                if(res.code=='200'){
                    this.stepVisible = true;

                    this.form4 = res.data.comOrderStepList;
                    this.form7 = res.data.apiCallLogList;
                    this.form5 = row;
                }else{
                    this.$message.error(res.message);
                }
            });
        },
        handleBack( row){
            getOrderBack(row).then(res => {
                if(res.code=='200'){
                    this.backVisible = true;  
                    this.form6 = res.data;
                    this.form5 = row;
                }else{
                    this.$message.error(res.message); 
                } 
            }); 
        },
        // 删除
        handDelete(index, row) {  
            this.form.id=row.id;  
            // 二次确认删除
            this.$confirm('该资源所有商品将删除，是否要删除？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(this.form).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success('删除成功'); 
                        this.$set(this.query, 'pageIndex', 1); 
                        this.getData();
                    }else if(res.code=='201'){
                        //处理该等级绑定的成员
                        this.$message.error("该资源商品仍有订单未结算，请手动结算订单！"); 
                    }else{
                        this.$message.error("删除失败"); 
                    } 
                });
            }) 
        },
        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData();
        }
    }
};
</script>

<style scoped> 
 
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 145px;
    display: inline-block;
}

.handle-input {
    width: 145px;
    display: inline-block;
}
.handle-del {
    float:right; 
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
    margin-left:0;
}
.mr15 {
    margin-right: 15px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
<style>
.el-table--small .el-table__cell{
    padding:3px 2px;
}
.el-table .cell{
    padding:3px 2px;
}
</style>
